import ValidateAllLoadAdjustments from './ValidateAllLoadAdjustments.js';
import ValidateSingleLoadAdjustment from './ValidateSingleLoadAdjustment.js';

const getAdjustmentsWarningMessage = (adjustment) => {
  const { minValidAmount, maxValidAmount, amount, display } = adjustment;
  let warningMessage = null;
  let isError = false;

  if (isNaN(amount)) {
    warningMessage = `${display} cannot contain letters or special characters.`;
    isError = true;
  } else if (!!minValidAmount && amount < minValidAmount && amount > 0) {
    warningMessage = `${display} below threshold (<${minValidAmount}).`;
  } else if (!!maxValidAmount && amount > maxValidAmount) {
    warningMessage = `${display} above threshold (>${maxValidAmount}).`;
  }

  return { warningMessage, isError };
};

export { ValidateAllLoadAdjustments, ValidateSingleLoadAdjustment, getAdjustmentsWarningMessage };
